import * as React from 'react';

import { AbacusControl, AbacusExperiment, AbacusVariant } from 'bernie-abacus';
import { ErrorBoundary } from 'bernie-view';

import { SearchResultsReviews } from './search-results-reviews';

export const SearchResultsReviewsExperimentControl = ({ reviews }) => (
  <AbacusExperiment name="PWA_SRP_reviews_placement">
    <AbacusControl>
      <ErrorBoundary label="hotel.search.listing.reviews">
        <SearchResultsReviews className="listing__reviews" reviews={reviews} />
      </ErrorBoundary>
    </AbacusControl>
    <AbacusVariant bucket={1} />
  </AbacusExperiment>
);

export const SearchResultsReviewsExperimentVariant = ({ reviews }) => (
  <AbacusExperiment name="PWA_SRP_reviews_placement">
    <AbacusControl />
    <AbacusVariant bucket={1}>
      <ErrorBoundary label="hotel.search.listing.reviews">
        <SearchResultsReviews className="listing__reviews" reviews={reviews} />
      </ErrorBoundary>
    </AbacusVariant>
  </AbacusExperiment>
);
